module.exports = __webpack_public_path__ + "static/img/title.d234f3e.png";


//////////////////
// WEBPACK FOOTER
// ./static/default/img/role3/title.png
// module id = EJKl
// module chunks = 7